module.exports = __webpack_public_path__ + "images/backgrounds/mountain/small.da8d70dd70d666361767.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/mountain/small.jpg
// module id = yUvD
// module chunks = 1